/**
 * Guide visual assets — filenames under /guides/items/
 * Canonical shared library: one item → one local WebP, reused across all guides.
 * Primary visual source: muonline.net/guides (localized). Alts: Dreamassets item IDs.
 */
export const G = (file) => `/guides/items/${file}`;

export const guideImg = {
  jewelChaos: G("jewel-of-chaos.webp"),
  jewelBless: G("jewel-of-bless.webp"),
  jewelSoul: G("jewel-of-soul.webp"),
  jewelLife: G("jewel-of-life.webp"),
  jewelCreation: G("jewel-of-creation.webp"),
  jewelSoulBundle: G("jewel-soul-bundle.webp"),
  jewelBlessBundle: G("jewel-bless-bundle.webp"),
  talismanLuck: G("talisman-luck.webp"),
  fragmentHorn: G("fragment-of-horn.webp"),
  brokenHorn: G("broken-horn.webp"),
  hornFenrir: G("horn-of-fenrir.webp"),
  fenrirRed: G("fenrir-red.webp"),
  fenrirBlue: G("fenrir-blue.webp"),
  fenrirBlack: G("fenrir-black.webp"),
  fenrirGold: G("fenrir-gold.webp"),
  splinterArmor: G("splinter-of-armor.webp"),
  blessGuardian: G("bless-of-guardian.webp"),
  clawBeast: G("claw-of-beast.webp"),
  chaosGoblin: G("chaos-goblin.webp"),
  chaosAxe: G("chaos-dragon-axe.webp"),
  chaosBow: G("chaos-nature-bow.webp"),
  chaosStaff: G("chaos-lighting-staff.webp"),
  wingElf: G("wing-elf.webp"),
  wingHeaven: G("wing-heaven.webp"),
  wingSatan: G("wing-satan.webp"),
  wingCurse: G("wing-curse.webp"),
  wingSpirits: G("wing-spirits.webp"),
  wingSoul: G("wing-soul.webp"),
  wingDragon: G("wing-dragon.webp"),
  wingDarkness: G("wing-darkness.webp"),
  wingDespair: G("wing-despair.webp"),
  capeLord: G("cape-lord.webp"),
  capeFighter: G("cape-fighter.webp"),
  lochFeather: G("loch-feather.webp"),
  lochCrest: G("loch-crest.webp"),
  condorFeather: G("condor-feather.webp"),
  condorFlame: G("condor-flame.webp"),
  wingStorm: G("wing-storm.webp"),
  wingEternal: G("wing-eternal.webp"),
  wingIllusion: G("wing-illusion.webp"),
  wingRuin: G("wing-ruin.webp"),
  capeEmperor: G("cape-emperor.webp"),
  wingDimension: G("wing-dimension.webp"),
  capeOverrule: G("cape-overrule.webp"),
  npcSebina: G("npc-sebina.webp"),
  npcMarlon: G("npc-marlon.webp"),
  npcDevin: G("npc-devin.webp"),
  npcWerewolf: G("npc-werewolf.webp"),
  npcGatekeeper: G("npc-gatekeeper.webp"),
  scrollEmperor: G("item-scroll-emperor.webp"),
  brokenSword: G("item-broken-sword.webp"),
  tearElf: G("item-tear-elf.webp"),
  soulShard: G("item-soul-shard.webp"),
  abyssalEye: G("item-abyssal-eye.webp"),
  ringHonor: G("item-ring-honor.webp"),
  darkStone: G("item-dark-stone.webp"),
  deathbeamFlame: G("item-deathbeam-flame.webp"),
  hellminerHorn: G("item-hellminer-horn.webp"),
  phoenixFeather: G("item-phoenix-feather.webp"),
  monDeathBeam: G("mon-death-beam.webp"),
  monHellMaine: G("mon-hell-maine.webp"),
  monPhoenix: G("mon-phoenix.webp"),
  monBalram: G("mon-balram.webp"),
  monDeathSpirit: G("mon-death-spirit.webp"),
  monSoram: G("mon-soram.webp"),
  monDarkElf: G("mon-dark-elf.webp"),
  cloakInvis: G("cloak-invisibility.webp"),
  scrollArchangel: G("scroll-archangel.webp"),
  bloodBone: G("blood-bone.webp"),
  devilsEye: G("devils-eye.webp"),
  devilsKey: G("devils-key.webp"),
  devilsInvite: G("devils-invitation.webp"),
  oldScroll: G("old-scroll.webp"),
  illusionCovenant: G("illusion-covenant.webp"),
  scrollBlood: G("scroll-blood.webp"),

  // Class evolution renders (t1–t3 only — no 4th class)
  classDkT1: G("class-dk-t1.webp"),
  classDkT2: G("class-dk-t2.webp"),
  classDkT3: G("class-dk-t3.webp"),
  classDwT1: G("class-dw-t1.webp"),
  classDwT2: G("class-dw-t2.webp"),
  classDwT3: G("class-dw-t3.webp"),
  classFeT1: G("class-fe-t1.webp"),
  classFeT2: G("class-fe-t2.webp"),
  classFeT3: G("class-fe-t3.webp"),
  classSuT1: G("class-su-t1.webp"),
  classSuT2: G("class-su-t2.webp"),
  classSuT3: G("class-su-t3.webp"),
  classMgT1: G("class-mg-t1.webp"),
  classMgT3: G("class-mg-t3.webp"),
  classDlT1: G("class-dl-t1.webp"),
  classDlT3: G("class-dl-t3.webp"),
  classRfT1: G("class-rf-t1.webp"),
  classRfT3: G("class-rf-t3.webp"),
};

export default guideImg;
